import { stores } from "../stores";
import _ from 'lodash';
import {SmartMetadataType} from "../stores/entity/extends/smartViewStore";
import {l} from "mam-core-react";
import entityTypes from 'src/types/entityTypes';
//无锡配置地址中需要读取权限，因此此处需要引入permissionUtil
import permissionUtil from "mam-common-utils/dist/modules/permissionUtil";
import { commonUtil } from 'mam-common-utils';

namespace entityUtil {
    export const getFormatFlagIconClassname = (v: number | undefined): string => {
        switch (v) {
            case 1:
                return 'list_cover_SD';
            case 2:
            case 3:
                return 'list_cover_HD';
            case 4:
                return 'list_cover_4K';
            default:
                return '';
        }
    }

    export const getEntityTypeShortName = (code?: string, ext?: string): string => {
        if (stores.configStore.config && stores.configStore.config.extTagEnable) {
            if ((ext == null || ext === '')) {
                if (!stores.configStore.config.typeTagEnable) {
                    return '';
                }
            } else {
                let ret = ext.replace('.', '').toUpperCase();
                if (ret.indexOf('?') > -1) {
                    ret = ret.substring(0, ret.indexOf('?'));
                }
                return ret;
            }
        }
        if (code == null || code === '' || (stores.configStore.config && !stores.configStore.config.typeTagEnable)) {
            return '';
        }
        let type;
        if (stores.configStore.config) {
            type = _.find(stores.configStore.config.entityTypes, { 'code': code });
            if (type == null) {
                type = _.find(stores.configStore.config.entityTypes, { namespace: code });
            }
        }
        if (type != null) {
            if (type.shortCode != null && type.shortCode.length > 0) {
                return type.shortCode;
            }
        }

        switch (code.toLowerCase()) {
            case 'video':
            case 'biz_sobey_video':
                return 'V';

            case 'audio':
            case 'biz_sobey_audio':
                return 'A';

            case 'picture':
            case 'biz_sobey_picture':
                return 'P';

            case 'document':
            case 'biz_sobey_document':
                return 'D';

            case 'hypermedia':
            case 'biz_sobey_hypermedia':
                return 'H';

            case 'dataset':
                return 'G';

            case 'rundown':
            case 'biz_sobey_rundown':
                return 'R';

            case 'script':
            case 'biz_sobey_script':
                return 'S';
            
            case 'album':
                return 'C';

            case 'other':
            case 'biz_sobey_other':
                return 'O';

            default:
                return code;
        }
    }
    /**
     * 打印元数据的方法
     * @param data 需要打印的表格的data{title:string,text:string}数组
     * @param clear 是否去除默认页眉页脚
     */
    export const printEntityData = (data: Array<{ title: string, text: string }>,clear?:boolean) => {
        const win = window.open('', '打印元数据');
        if (win) {
            const initStyle = '<style media="print">@page{size: auto;margin: 0mm;}</style>'
            let tbody:string = ''
            data.forEach(item=>{
                tbody += `<tr><td style="max-width:100px;padding:5px;text-align:center;word-wrap:break-word;word-break:break-all;white-space:normal;">${item.title}</td><td style="max-width:300px;padding:5px;word-wrap:break-word;word-break:break-all;white-space:normal;">${item.text}</td></tr>`
            })
            const table:string = `<table border="1" cellspacing="0" width="100%"><tbody>${tbody}</tbody></table>`
            const printData:string = `<div style="padding:20px;box-sizing:border-box;width:100%;">${(clear ? initStyle : '') + table}</div>`
            win.document.write(printData);
            win.print();
            win.close();
        }
    }

    export enum ViewEntityType{
        EDIT = 1,
        BROWSE = 2
    }

    /**
     * 获取浏览素材url
     *
     * @param entity
     * @param viewtype viewtype='edit' or viewtype='browse'
     */
    export const getViewEntityUrl = (entity: any, viewtype: ViewEntityType) => {
        let newEntity: any = $.extend({}, entity);
        let url = '';
        viewtype = viewtype || 'browse';
        if (viewtype === ViewEntityType.EDIT) {
            url = stores.configStore.config.entity.editUrl;
        }
        else {
            url = stores.configStore.config.entity.viewUrl;
            if (newEntity.keyword === undefined) {
                newEntity.keyword = '';
            }
        }

        if (newEntity.siteName !== undefined){
            newEntity.siteCode = newEntity.siteName;
        }
        if (newEntity.contentid !== undefined){
            newEntity.contentId = newEntity.contentid;
        }
        if (newEntity.siteCode === undefined) {
            newEntity.siteCode = stores.configStore.config.defaultSiteCode;
        }

        if (newEntity.contentId === undefined) {
            newEntity.contentId = '';
        }

        // 西宁台片段预览地址处理
        if (newEntity.type === 'sequence' 
            || newEntity.type === 'scene'
            || newEntity.type === 'shot'){
            newEntity.contentId = newEntity.contentId.substring(0, newEntity.contentId.indexOf('_'))
            url = commonUtil.addUrlParam(url, 'trimin=${inpoint}')
            url = commonUtil.addUrlParam(url, 'trimout=${outpoint}')
        }

        if (stores.userStore.currentUser){
            newEntity.token = stores.userStore.currentUser.userToken;
        }

        _.templateSettings = {
            interpolate: /\$\{(.+?)\}/g
        };
        let compiled = _.template(url);
        url = compiled(newEntity);

        //央视国际无锡定制跳转详情，若是视频，则使用系统配置详情地址，若非视频则使用原先地址
        if(newEntity.type !== 'video' && stores.configStore.config && stores.configStore.config.wuXiCustomSwitch){
            url = `/entity/${newEntity.contentId}/${newEntity.siteCode}`
        }
        if(newEntity.type === 'video' && stores.configStore.config && stores.configStore.config.wuXiCustomSwitch){
            url += `&from=cc&operate=${permissionUtil.judge('wx_editEntity')}`
        }
        return url;
    }
    /**
     * 获取片段检索的url
     */
    export const getEntityPartUrl = (entity: any):string => {
        let editUrl = stores.configStore.config.entity.editUrl;
        if (editUrl.indexOf('/iEntity') === -1){
            let url = `/entityPart/${entity.contentId}`
            if(entity.type === SmartMetadataType.story){
                url = '/entityPart/story/' + entity.contentId + '/' + entity.storyid + (entity.siteCode ? ('/' + entity.siteCode) : '');
            }
            else if(entity.type === SmartMetadataType.scene){
                url = '/entityPart/scene/' + entity.contentId + '/' + entity.sceneid + (entity.siteCode ? '/' + entity.siteCode : '');
            }else{
                url = '/entityPart/shot/' + entity.contentId + '/' + entity.shotid + (entity.siteCode ? '/' + entity.siteCode : '');
            }
            if(entity.siteName){
                url += `/${entity.siteName}`
            }
            else if (entity.site_){
                url += `/${entity.site_}`
            }
            if(entity.inpoint !== undefined && entity.outpoint !== undefined){
                url += `?inpoint=${entity.inpoint}&outpoint=${entity.outpoint}`
            }
            return url
        }
        else {
            let url = `/iEntityPart/${entity.contentId}`
            if(entity.type === 'story'){
                url = '/iEntityPart/story/' + entity.contentId + '/' + entity.guid_ + (entity.siteCode ? ('/' + entity.siteCode) : '');
            }
            else if(entity.type === 'scene'){
                url = '/iEntityPart/scene/' + entity.contentId + '/' + entity.guid_ + (entity.siteCode ? '/' + entity.siteCode : '');
            }else{
                url = '/iEntityPart/shot/' + entity.contentId + '/' + entity.guid_ + (entity.siteCode ? '/' + entity.siteCode : '');
            }
            if(entity.siteName){
                url += `/${entity.siteName}`
            }
            else if (entity.site_){
                url += `/${entity.site_}`
            }
            if(entity.inpoint !== undefined && entity.outpoint !== undefined){
                url += `?inpoint=${entity.inpoint}&outpoint=${entity.outpoint}`
            }
            return url
        }
    }
    /**
     * 获取类型
     * @param {string} code
     */
    export const entityTypeName = (code: string): string => {
        if (_.isEmpty(code)) {
            return ''
        }
        const type = _.find(stores.configStore.config.entityTypes, { code })
        if (!type) {
            if (code === 'hypermedia') {
                return l(`com.${code}`, '图文')
            }
            else if (code === 'folder') {
                return l(`com.${code}`, '文件夹');
            }
            else if (code === 'story'){
                return '片段层'
            }
            else if (code === 'scene'){
                return '场景层'
            }
            else if (code === 'shot'){
                return '镜头层'
            }
            return code
        }
        return l(`com.${code}`, type.name)
    }
    /**
     * 获取智能分析状态
     * @param {string} state
     */
    export const entityAnalysisState = (state: string): string => {
        if (_.isEmpty(state)) {
            return ''
        }
        switch (state) {
            case '0':
                return l('newEntity.unAnalysis', '未分析')
            case '1':
                return l('newEntity.hasAudit', '已审校')
            case '10':
                return l('newEntity.auditing', '审校中')
            case '20':
                return l('newEntity.isAnalysing', '分析中')
            case '21':
                return l('newEntity.isFinishAnalysis', '分析完成')
            case '-20':
                return l('newEntity.isAnalysisFailed', '分析失败');
            default:
                return ''
        }
    }

    /**
     * 获取智能分析状态
     * @param {string} state
     */
    export const entityAnalysisState2 = (state: string): string => {
        switch (state) {
            case '-1':
                return '<span class="dot-info" style="color:#D9001B;">分析失败</span>'
            case '1':
                return '<span class="dot-info" style="color:#F59A23;">分析中</span>'
            case '2':
                return '<span class="dot-info" style="color:#03BB24;">分析完成</span>'
            default:
                return '<span class="dot-info" style="color:#AAAAAA;">未分析</span>'
        }
    }
    //获取barcodes，isFromI: 是否来自i开头的模块
    export const getBarcodes = (item: any, isFromI?: boolean): string => {
        if(isFromI){
            return (item.filestorageinfo && Array.isArray(item.filestorageinfo) && item.filestorageinfo.length > 0) ? item.filestorageinfo.join(',') : '未在介质'.l('search.065');
        }
        return (item.barcodes && item.barcodes.length > 0) ? item.barcodes.join(',') : '未在介质'.l('search.065');
    }
    //判断是否为可发起归档状态，也就是已存储状态，isFromI: 是否来自i开头的模块
    export const isArchiveStatus = (item: any, isFromI?: boolean): boolean => {
        if(isFromI){
            return item.mam_archivestatus && item.mam_archivestatus.length > 0 && _.find(item.mam_archivestatus, (o) => {
                return o === 'HDD';
            }) !== undefined;
        }
        return item.archiveList && item.archiveList.length > 0 && _.find(item.archiveList, (o) => {
            return o === 'HDD';
        }) !== undefined;
    }
    //判断是否为需回迁状态，isFromI: 是否来自i开头的模块
    export const isRestoreStatus = (item: any, isFromI?: boolean): boolean => {
        if(isFromI){
            return item.mam_archivestatus && item.mam_archivestatus.length > 0 &&
            _.find(item.mam_archivestatus, (o)=>o === 'HDD') === undefined &&
            _.find(item.mam_archivestatus, (o)=>o !== 'HDD') !== undefined
        }
        return item.archiveList && item.archiveList.length > 0 &&
        _.find(item.archiveList, (o)=>o === 'HDD') === undefined &&
        _.find(item.archiveList, (o)=>o !== 'HDD') !== undefined
    }
    //翻译介质状态
    export const getTapeStatus = (item: any) => {
        switch (item.dynamicResponse.tapestatus) {
            case '1':
                return '在线'.l('tape.onLine');
            case '2':
                return '离线'.l('tape.offline');
            default:
                return '未知'.l('tape.unknown');
        }
    }

    
}
export default entityUtil;
